/**
 * lazy-video.js
 * Reproduce los videos de fondo (hero / banner) solo cuando entran al viewport.
 *
 * Estrategia "poster-first": el markup se renderiza con `preload="none"` y sin
 * `autoplay`, mostrando el poster del video como LCP liviano. Este script:
 *   - Reproduce el video al entrar en viewport (IntersectionObserver).
 *   - Lo pausa al salir, para ahorrar CPU/batería en carruseles.
 *   - Nunca toca los wrappers ocultos del breakpoint que no corresponde
 *     (display:none => no intersecta => no descarga el video).
 *   - Respeta prefers-reduced-motion: deja el poster sin reproducir.
 *
 * Selector: cualquier `video` dentro de un elemento con [data-lazy-video].
 */
(function () {
  if (window.__lazyVideoInit) return;
  window.__lazyVideoInit = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Observer único y persistente: se reutiliza entre llamadas a init() para no
  // duplicar observadores al recargar secciones en el editor de temas.
  var observer;

  function play(video) {
    if (!video) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* autoplay bloqueado: el poster permanece visible */
      });
    }
  }

  function init() {
    // Solo observa wrappers que aún no estén siendo observados (idempotente).
    var wrappers = document.querySelectorAll('[data-lazy-video]:not([data-lazy-video-observed])');
    if (!wrappers.length || reduceMotion) return;

    // Fallback para navegadores sin IntersectionObserver: reproduce los visibles.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < wrappers.length; i++) {
        if (wrappers[i].offsetParent !== null) {
          play(wrappers[i].querySelector('video'));
        }
      }
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              play(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { rootMargin: '100px 0px', threshold: 0.1 }
      );
    }

    wrappers.forEach(function (wrapper) {
      observer.observe(wrapper);
      wrapper.setAttribute('data-lazy-video-observed', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor de temas: las secciones se re-renderizan tras DOMContentLoaded; re-observa
  // los nuevos wrappers cuando una sección se carga.
  document.addEventListener('shopify:section:load', init);
})();
